// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchBar_root__62QaI","input":"SearchBar_input__Ubjau","rotation":"SearchBar_rotation__cIy0_"};